module.exports = __webpack_public_path__ + "static/media/downloads.2acf5178.csv";